var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"shop _min-h-screen"},[(_vm.doc)?[_c('slice-body',{attrs:{"slices":_vm.doc.data.body1}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }